"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Button = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _gtm = _interopRequireDefault(require("../../helpers/gtm"));

var _link = require("../../helpers/link");

var _withMapping = _interopRequireDefault(require("../../Context/withMapping"));

require("./style.scss");

var _excluded = ["href", "dispatch", "className", "children", "primary", "inverted", "language", "enableLoader", "loading", "htmlType"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Button = function Button(_ref) {
  var href = _ref.href,
      dispatch = _ref.dispatch,
      className = _ref.className,
      children = _ref.children,
      primary = _ref.primary,
      inverted = _ref.inverted,
      language = _ref.language,
      enableLoader = _ref.enableLoader,
      loading = _ref.loading,
      htmlType = _ref.htmlType,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = (0, _classnames.default)('Button', className, {
    'Button--primary': primary,
    'Button--inverted': inverted,
    'is-loading': loading
  });

  var onClick = function onClick(event) {
    if (loading) return; // Using element.innerText gives us purely the text of the element which is
    // perfect for the tracking event. We don't want a string containing HTML.

    var text = event.target ? event.target.innerText : 'Unknown';

    _gtm.default.trackUserEvent('button', 'click', text, href);

    if (props.onClick) {
      props.onClick(event);
    }
  };

  if (!href) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/button-has-type
      _react.default.createElement("button", _extends({
        type: htmlType,
        className: classes,
        href: href
      }, props, {
        onClick: onClick
      }), children)
    );
  }

  return (0, _link.isExternalLink)(href) ? /*#__PURE__*/_react.default.createElement("a", _extends({
    className: classes,
    href: href,
    target: "_blank",
    rel: "noreferrer noopener"
  }, props, {
    onClick: onClick
  }), children) : /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, _extends({
    to: href,
    className: classes
  }, props, {
    onClick: onClick
  }), children);
};

exports.Button = Button;
Button.defaultProps = {
  primary: true,
  inverted: false,
  disabled: false,
  href: null,
  enableLoader: false,
  htmlType: 'button'
};
Button.propTypes = {
  href: _propTypes.default.string,
  primary: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  inverted: _propTypes.default.bool,
  enableLoader: _propTypes.default.bool,
  htmlType: _propTypes.default.oneOf(['button', 'submit', 'reset'])
};

var _default = (0, _withMapping.default)(Button);

exports.default = _default;